import { Color, Spacing } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import FieldInput from 'dashboard/components-lib/FieldInput/FieldInput';
import { Z_INDICES } from 'dashboard/styles/variables';
import { Label, Paragraph } from 'design-system/components/Text';
import Tooltip from 'design-system/components/Tooltip';
import { FieldSchema } from 'lib/fields';

const LabeledFieldInputContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${Spacing[2]};
`;

const LabelContainer = styled('div')`
  flex: 1;
  margin-right: ${Spacing[1]};
`;

const FieldInputContainer = styled('div')`
  flex: 2;
`;

const StyledRedText = styled('span')`
  color: ${Color.TextDanger};
`;

const FieldNameWithTooltip = styled.span`
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: 4px;
  text-decoration-thickness: 1px;
  text-decoration-color: ${Color.BorderHairline};
`;

interface LabeledFieldInputProps {
  fieldSchema: FieldSchema;
  disabled: boolean;
  onChange: (value?: any, key?: any) => void;
  onBlur?: () => void;
  id?: string;
  value?: any;
  required?: boolean;
  referenced?: boolean;
}

const LabeledFieldInput = ({
  fieldSchema,
  disabled,
  onChange,
  onBlur,
  id,
  value,
  required,
  referenced,
}: LabeledFieldInputProps) => {
  return (
    <LabeledFieldInputContainer>
      <LabelContainer>
        <Label id={`${id}_label`}>
          {required ? (
            <>
              {fieldSchema.label}
              <StyledRedText>*</StyledRedText>
            </>
          ) : referenced ? (
            <Tooltip
              side='top'
              trigger={
                <FieldNameWithTooltip>
                  {fieldSchema.label} <CircleAlertIcon size={12} />
                </FieldNameWithTooltip>
              }
              zIndex={Z_INDICES.modalElevated}
            >
              <Paragraph>Referenced field</Paragraph>
            </Tooltip>
          ) : (
            fieldSchema.label
          )}
        </Label>
      </LabelContainer>
      <FieldInputContainer>
        <FieldInput
          fieldSchema={fieldSchema}
          disabled={disabled}
          onChange={(value) => onChange(value, fieldSchema.key)}
          onBlur={onBlur}
          id={id}
          value={value}
          ariaLabel={`${id}_label`}
        />
      </FieldInputContainer>
    </LabeledFieldInputContainer>
  );
};

export default LabeledFieldInput;
